import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { CookieSettingsContainer } from "./cookie-settings.container";

const DIRECTIVES = [CookieSettingsContainer];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatProgressSpinnerModule,
		CoreContentModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CookieSettingsModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
